import React, { Component } from "react";
import Paper from '@material-ui/core/Paper';
import MaterialTable from 'material-table';

import './OrdersList.scss';

export default class OrdersList extends Component {
    render() {
        function createData(OrderID, ProductName, Category, Asin, OrderDate, PaymentType, ShippingAddressCity, ShippingAddressState, ItemSubtotal, ItemSubtotalTax, ItemTotal) {
            return { OrderID, ProductName, Category, Asin, OrderDate, PaymentType, ShippingAddressCity, ShippingAddressState, ItemSubtotal, ItemSubtotalTax, ItemTotal };
        }

        const rows = this.props.orders.map(order => createData(
            order.OrderID,
            order.Title,
            order.Category,
            order.Asin,
            order.OrderDate,
            order.PaymentInstrumentType,
            order.ShippingAddressCity,
            order.ShippingAddressState,
            order.ItemSubtotal,
            order.ItemSubtotalTax,
            order.ItemTotal
        ));

        return (
            <div className="Orders-List-wrapper">
                <Paper>
                    <MaterialTable
                        columns={[
                            {
                                title: "Title", field: "ProductName", render: row => {
                                    return (
                                        <React.Fragment>
                                            <a className="link h5" href={`https://amazon.com/dp/${row['Asin']}`} target="_blank" rel="noopener noreferrer"
                                                title={row.ProductName}>
                                                {
                                                    row.ProductName.length > 45
                                                        ? row.ProductName.substring(0, 45) + '...'
                                                        : row.ProductName
                                                }
                                            </a>
                                            <p>{row.Category}</p>
                                        </React.Fragment>
                                    )
                                }
                            },
                            {
                                title: "Order date", field: "OrderDate",
                                customSort: (a, b) => new Date(a.OrderDate) - new Date(b.OrderDate)
                            },
                            {
                                title: "Payment type", field: "PaymentType" },
                            {
                                title: "Shipped in", field: '', render: (row) => `${row.ShippingAddressCity}, ${row.ShippingAddressState}`
                            },
                            {
                                title: "Subtotal", field: "ItemSubtotal", type: "numeric",
                                render: row => `$${row.ItemSubtotal}`
                            },
                            {
                                title: "Taxes", field: "ItemSubtotalTax", type: "numeric",
                                render: row => `$${row.ItemSubtotalTax}`
                            },
                            {
                                title: "Total", field: "ItemTotal", type: "numeric",
                                render: row => `$${row.ItemTotal}`
                            },
                            {
                                title: 'Category', field: 'Category',
                                hidden: true, filtering: true
                            }
                        ]}
                        data={rows}
                        title="Orders History"
                        options={{
                            pageSize: 25,
                            pageSizeOptions: [10, 25, 50, rows.length],
                            doubleHorizontalScroll: true
                        }}
                    />
                </Paper>
            </div>
        );
    }
}
